import { create } from 'zustand';
import type { ToastVariant } from '@sportschool/shared-types';

export interface Toast {
  id: string;
  message: string;
  variant: ToastVariant;
  code?: string;
  args?: Record<string, any>;
}

interface ToastState {
  toasts: Toast[];
  addToast: (message: string, variant?: ToastVariant, code?: string, args?: Record<string, any>) => void;
  removeToast: (id: string) => void;
}

let toastId = 0;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  addToast: (message, variant = 'info', code, args) =>
    set((state) => ({
      toasts: [...state.toasts, { id: String(++toastId), message, variant, code, args }],
    })),
  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}));

export const toast = {
  success: (message: string, code?: string, args?: Record<string, any>) => useToastStore.getState().addToast(message, 'success', code, args),
  error: (message: string, code?: string, args?: Record<string, any>) => useToastStore.getState().addToast(message, 'error', code, args),
  info: (message: string, code?: string, args?: Record<string, any>) => useToastStore.getState().addToast(message, 'info', code, args),
  warning: (message: string, code?: string, args?: Record<string, any>) => useToastStore.getState().addToast(message, 'warning', code, args),
};
